<section class="flex h-full w-full flex-col overflow-hidden bg-white text-slate-900" role="dialog">
  <header class="flex shrink-0 items-center gap-3 border-b !border-slate-100 px-4 py-3">
    <div class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>account_balance</app-icon>
    </div>
    <h2 class="min-w-0 flex-1 truncate !m-0 !text-base !font-bold !leading-6">
      {{ (service ? 'board_payments.directories.services.edit_title' : 'board_payments.directories.services.add_title') | translate }}
    </h2>
    <app-button btnType="icon" [ariaLabel]="'close' | translate" (onChangeClick)="close.emit()">
      <app-icon>close</app-icon>
    </app-button>
  </header>

  @if (loading) {
    <div class="flex flex-1 flex-col gap-4 px-4 py-4">
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-24 animate-pulse rounded-lg bg-slate-100"></div>
    </div>
  } @else {
    <form class="crm-scroll flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4" (ngSubmit)="save()">
      <app-input
        [formControl]="form.controls.name"
        [label]="'board_payments.fields.name' | translate"
        [required]="true"
        [placeholder]="'board_payments.directories.services.name_placeholder' | translate"
      />

      <app-select
        [formControl]="form.controls.integration"
        [options]="integrationOptions"
        optionLabel="name"
        optionValue="code"
        [required]="true"
        [label]="'board_payments.fields.integration' | translate"
        [placeholder]="'board_payments.directories.services.integration_placeholder' | translate"
      />

      @if (integration === 'bank_qr') {
        <div class="flex flex-col gap-4 rounded-lg border !border-slate-200 bg-slate-50/60 p-3">
          <app-input
            [formControl]="settingsForm.controls.legal_name"
            [label]="'board_payments.fields.legal_name' | translate"
            [required]="true"
            [placeholder]="'board_payments.directories.services.legal_name_placeholder' | translate"
          />
          <app-input
            [formControl]="settingsForm.controls.tax_id"
            [label]="'board_payments.fields.tax_id' | translate"
            [required]="true"
            [pKeyFilter]="digitsOnly"
            placeholder="12345678"
          />
          <app-input
            [formControl]="settingsForm.controls.iban"
            [label]="'board_payments.fields.iban' | translate"
            [required]="true"
            placeholder="UA000000000000000000000000000"
          />
          <app-textarea
            [formControl]="settingsForm.controls.purpose"
            [label]="'board_payments.fields.purpose' | translate"
            [maxLength]="purposeMaxLength"
            [placeholder]="'board_payments.directories.services.purpose_placeholder' | translate"
          />
          <app-input
            inputType="number"
            [formControl]="settingsForm.controls.link_ttl_days"
            [label]="'board_payments.fields.link_ttl_days' | translate"
            [required]="true"
            [minFractionDigits]="0"
            [min]="1"
            [max]="linkTtlMax"
          />
          <div class="flex flex-col gap-1">
            <app-select
              [formControl]="settingsForm.controls.payment_type_id"
              [options]="paymentTypeOptions"
              optionLabel="name"
              optionValue="id"
              [required]="true"
              [label]="'board_payments.fields.payment_type' | translate"
              [placeholder]="'board_payments.directories.services.payment_type_placeholder' | translate"
            />
            <p class="!m-0 text-xs leading-5 text-slate-400">
              {{ 'board_payments.directories.services.payment_type_hint' | translate }}
            </p>
          </div>
        </div>
      }

      <app-input
        [formControl]="form.controls.sort_order"
        [label]="'board_payments.fields.sort_order' | translate"
        [pKeyFilter]="digitsOnly"
        [placeholder]="service ? '' : ('board_payments.directories.order_placeholder' | translate)"
      />

      <div class="flex items-center justify-between gap-3">
        <span class="text-sm font-medium text-slate-700">{{ 'board_payments.fields.is_active' | translate }}</span>
        <app-toggle [formControl]="form.controls.is_active">
          <span class="sr-only">{{ 'board_payments.fields.is_active' | translate }}</span>
        </app-toggle>
      </div>
    </form>

    <footer class="flex shrink-0 gap-2 border-t !border-slate-100 px-4 py-3">
      <app-button btnType="stroked" class="flex-1" [customClass]="'w-full !h-10 !rounded-lg'" (onChangeClick)="close.emit()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button class="flex-1" [customClass]="'w-full !h-10 !rounded-lg'" [disabled]="saving" (onChangeClick)="save()">
        {{ (saving ? 'saving' : service ? 'save' : 'add') | translate }}
      </app-button>
    </footer>
  }
</section>
